import { useEffect } from 'react'
import {
  formatCurrencyInput,
  CurrencyFormatType,
  usePrevious
} from '@sequencehq/utils'
import { RateDisplay } from 'Invoices/types'

type UseCurrencyFormattingProps = {
  value: string
  onChange: (value: string) => void
  rateDisplay: RateDisplay
  formatType: CurrencyFormatType | null
}

export const useCurrencyFormatting = ({
  value,
  onChange,
  rateDisplay,
  formatType
}: UseCurrencyFormattingProps) => {
  const prevRateDisplay = usePrevious(rateDisplay)

  const handleBlur = () => {
    if (formatType) {
      const formattedValue = formatCurrencyInput(value, formatType)
      if (formattedValue !== value) {
        onChange(formattedValue)
      }
    }
  }

  // Reformat when rate display changes
  useEffect(() => {
    if (prevRateDisplay !== rateDisplay && value && formatType) {
      const formattedValue = formatCurrencyInput(value, formatType)
      if (formattedValue !== value) {
        onChange(formattedValue)
      }
    }
  }, [rateDisplay, value, onChange, formatType, prevRateDisplay])

  return { handleBlur }
}
